<template>
    <div class="table-fields">
      <div class="tr">
        <div class="td">
          <i class="fa fa-check-square-o" v-if="fieldIsResolved(duplicate.id, fieldKey)"></i>

          <div class="form-check form-check-inline mr-0" v-else>
            <input type="checkbox" class="form-check-input" :name="name(duplicate.id, fieldKey)"
                   @change="uncheckOtherFieldSelections(duplicate.id, fieldKey)" :value="duplicate.id"
                   v-model="selectedFields[fieldKey]">
          </div>
        </div>
        <div class="td">
          <input v-if="field['type'] !== 'image'" class="form-control readonly-control" type="text"
                 :class="fieldIsResolved(duplicate.id, fieldKey) ? 'no-diff' : 'diff'"
                 :value="duplicate[fieldKey]" readonly>
          <img v-if="field['type'] === 'image'" :src="duplicate[fieldKey]" class="img-thumbnail img-lg">
        </div>
      </div>
    </div>
</template>

<script>

import ApplicationsMerge from "../../mixins/ApplicationsMerge";

export default {
  mixins: [ApplicationsMerge],

  props: {
    application: {
      type: Object,
      required: true
    },
    fieldKey: {
      type: String,
      required: true
    },
    field: {
      type: Object,
      required: true
    },
    overrideFields: {
      type: Object,
      required: true
    },
    selectedFields: {
      type: Object,
      required: true
    },
    duplicate: {
      type: Object,
      required: true
    },
    duplicateIds: {
      type: Array,
      required: true
    },
  },

  methods: {

    name(appId, fieldName) {
      return fieldName + '[' + appId + ']';
    },

    // Uncheck other field's checkboxes to be sure only one can be checked in a time.
    uncheckOtherFieldSelections(appId, fieldKey) {
      let checkboxChecked = this.selectedFields[fieldKey].includes(appId);

      this.duplicateIds.forEach((dupId) => {
        if (checkboxChecked && (dupId !== appId)) {
          let index = this.selectedFields[fieldKey].indexOf(dupId);
          if (index >= 0) {
            this.selectedFields[fieldKey].splice(index, 1);
          }
        }
      });

      if (checkboxChecked) {
        this.overrideFields[fieldKey] = this.duplicate[fieldKey];
      } else {
        this.overrideFields[fieldKey] = this.application[fieldKey];
      }
    },

    // Determine if field is not empty and equal to original value.
    // (duplicate's field should be highlighted if it is not empty and not equal to application original value)
    fieldIsResolved(duplicateId, fieldKey) {

      return this.normalizeValue(this.duplicate[fieldKey]) === this.normalizeValue(this.application[fieldKey]);
    },
  },

}
</script>

<style scoped>

.diff {
  background-color: #fafad2;
}

.no-diff {
  background-color: #ffffff;
}

.table-fields {
  display: table;
  width: 100%;
}

.tr {
  display: table-row;
}

.td {
  display: table-cell;
  padding: 5px;
}

.readonly-control {
  border: none;
}

del, ins {
  padding: 2px 5px;
  border-radius: 5px;
}

</style>
